document.addEventListener('livewire:navigated', () => {
    const taskId = (new URL(window.location.href).searchParams.get('showTask'));
    if (taskId) {
        dispatchEvent(new CustomEvent('open-task', {"detail": {task: taskId}}))
    }
})
